import { render } from "./ResourcesFilterSheet.vue?vue&type=template&id=8f12e4b8"
import script from "./ResourcesFilterSheet.vue?vue&type=script&lang=js"
export * from "./ResourcesFilterSheet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__